import { Link } from "gatsby";
import React, { useState } from "react";
import { slug } from "../../utils/slug";
import { navigate } from "../../utils/navigate";
import Appointment from "../Appointment";

const CustomLink = ({ data, cls, children }) => {
  const [popup, setPopup] = useState(false);

  const btnEvent = (txt) => {
    if (typeof window !== "undefined" && window.dataLayer) {
      window.dataLayer.push({
        event: "btn_click",
        eventLable: txt,
      });
    }
  };

  const btnEvent2 = (txt) => {
    setPopup(!popup);
    if (typeof window !== "undefined" && window.dataLayer) {
      window.dataLayer.push({
        event: "btn_click",
        eventLable: txt,
      });
      window.dataLayer.push({
        event: "appointment_btn_click",
      });
    }
  };

  return (
    <>
      {data?.linkType === "slug" && (
        <Link
          className={cls}
          to={slug(data.slug.current)}
          onClick={() => btnEvent(data.buttonText)}
        >
          {children}
        </Link>
      )}{" "}
      {data?.linkType === "url" && (
        <a
          className={cls}
          href={data.url}
          target="_blank"
          onClick={() => btnEvent(data.buttonText)}
        >
          {children}
        </a>
      )}{" "}
      {data?.linkType === "sectionId" && (
        <button onClick={() => navigate(data.sectionId)} className={cls}>
          {children}
        </button>
      )}
      {data?.linkType === "appointmentPopup" && (
        <button onClick={() => btnEvent2(data.buttonText)} className={cls}>
          {children}
        </button>
      )}
      {popup && <Appointment closeModal={() => setPopup(false)} />}
    </>
  );
};

export default CustomLink;
